import React from "react";
import { connect } from "react-redux";

import i18n from "utils/I18n";
import { openLoginPage } from "utils/SSOUtil";
import { SignInSection } from "component/common/navigator/RightComponent";
import MobileViewProfileSubNavigator from "component/profile/MobileViewProfileSubNavigator";
import { Container } from "react-bootstrap";

const SignInMobile = ({
  isLogin,
  isOpenInOtherSite,
}) => {
  return (
    <>
      {isLogin ? null :
        <>
          <SignInSection
            isLogin={isLogin}
            isOpenInOtherSite={isOpenInOtherSite}
            loginOnClick={() => {
              openLoginPage({ locale: i18n?.language || 'en' })
            }}
          />
          <Container >
            <MobileViewProfileSubNavigator />
          </Container>
        </>
      }
    </>
  )
}

const mapPropsToState = (state) => ({
  isLogin: state.users.isLogin,
  isOpenInOtherSite: state.users.isOpenInOtherSite,
});

export default connect(mapPropsToState)(SignInMobile);